import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const CGU = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <div className="pt-20 pb-12 bg-slate-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-lg shadow-lg p-8 lg:p-12">
              <h1 className="text-3xl font-bold text-slate-900 mb-8">
                Conditions Générales d'Utilisation
              </h1>
              
              <div className="space-y-8 text-slate-600 leading-relaxed">
                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Objet</h2>
                  <p>
                    Les présentes conditions générales d'utilisation (CGU) ont pour objet de définir les modalités 
                    et conditions d'utilisation du site internet de SHADOWTACT SARL, société spécialisée dans 
                    l'import-export et la vente de produits électroniques, ménagers, vêtements, chaussures et 
                    produits de première nécessité.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Identification de l'entreprise</h2>
                  <p>
                    <strong>Raison sociale :</strong> SHADOWTACT SARL<br />
                    <strong>Siège social :</strong> 5, Allée de la Grande Treille, 35200 Rennes<br />
                    <strong>Téléphone :</strong> 01 85 09 91 73 <br />
                    <strong>Email :</strong> info@shadowtact.fr <br />
                    <strong>Activité :</strong> Import-export et vente en ligne de produits non réglementés
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Accès au site</h2>
                  <p>
                    L'accès au site est gratuit et ouvert à tous les utilisateurs disposant d'un accès à Internet. 
                    SHADOWTACT SARL se réserve le droit de suspendre, modifier ou interrompre l'accès au site 
                    à tout moment sans préavis.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Utilisation du site</h2>
                  <p>
                    L'utilisateur s'engage à utiliser le site de manière conforme à la loi et aux présentes CGU. 
                    Il est interdit de :
                  </p>
                  <ul className="list-disc list-inside mt-2 ml-4 space-y-1">
                    <li>Utiliser le site à des fins illégales ou non autorisées</li>
                    <li>Tenter d'accéder aux systèmes informatiques de SHADOWTACT SARL</li>
                    <li>Transmettre des virus ou codes malveillants</li>
                    <li>Porter atteinte aux droits de propriété intellectuelle</li>
                  </ul>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Propriété intellectuelle</h2>
                  <p>
                    Tous les éléments du site (textes, images, logos, marques) sont la propriété exclusive de 
                    SHADOWTACT SARL ou de ses partenaires. Toute reproduction, représentation, modification ou 
                    adaptation de tout ou partie de ces éléments est interdite sans autorisation préalable.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Données personnelles</h2>
                  <p>
                    Les informations collectées via les formulaires de contact sont utilisées uniquement dans le 
                    cadre de la relation commerciale. Conformément au RGPD, l'utilisateur dispose d'un droit 
                    d'accès, de rectification et de suppression de ses données personnelles.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Responsabilité</h2>
                  <p>
                    SHADOWTACT SARL s'efforce d'assurer l'exactitude des informations diffusées sur le site, 
                    mais ne peut garantir leur exhaustivité ou leur mise à jour permanente. L'entreprise décline 
                    toute responsabilité en cas d'interruption du site ou d'erreurs dans les informations diffusées.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Cookies</h2>
                  <p>
                    Le site peut utiliser des cookies techniques nécessaires à son bon fonctionnement. 
                    L'utilisateur peut configurer son navigateur pour refuser les cookies, mais cela peut 
                    affecter le fonctionnement du site.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Droit applicable et juridiction</h2>
                  <p>
                    Les présentes CGU sont soumises au droit français. En cas de litige, les tribunaux de Rennes 
                    seront seuls compétents.
                  </p>
                </div>

                <div>
                  <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Modification des CGU</h2>
                  <p>
                    SHADOWTACT SARL se réserve le droit de modifier les présentes CGU à tout moment. 
                    Les nouvelles conditions seront applicables dès leur mise en ligne sur le site.
                  </p>
                </div>

                <div className="bg-slate-50 p-6 rounded-lg mt-8">
                  <p className="text-sm text-slate-500">
                    <strong>Dernière mise à jour :</strong> Janvier 2025
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CGU;